import { mapGetters } from "vuex";

export default {
  name: "ProAgeEvents",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {
      currentPlayingVideo: null,
    };
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      content: "proAge/content",
    }),
  },
  methods: {
    toggleVideo(videoId) {
      const video = this.$refs[`video-${videoId}`][0];

      if (this.currentPlayingVideo === videoId) {
        video.pause();
        this.currentPlayingVideo = null;
      } else {
        if (this.currentPlayingVideo) {
          const currentVideo = this.$refs[`video-${this.currentPlayingVideo}`][0];
          currentVideo.pause();
          currentVideo.currentTime = 0;
        }

        video.muted = false;
        video.play();
        this.currentPlayingVideo = videoId;
      }
    },
    stopVideo(videoId) {
      const video = this.$refs[`video-${videoId}`][0];
      video.pause();
      video.currentTime = 0;
      this.currentPlayingVideo = null;
    },
  },
};
